import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jiahao",
  "use": "icon-jiahao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jiahao\"><path fill=\"#515151\" d=\"M1023.937 409.572H614.349V0.063H409.554v409.509H0.062v204.806h409.492v409.559h204.795V614.378h409.588V409.572z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol